var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpBox",
    { staticClass: "flex-fill", attrs: { direction: "row" } },
    [
      _c(
        "div",
        { staticClass: "mr-3" },
        [
          _c("Icon", {
            attrs: {
              icon: "ri:import-line",
              tooltip: _vm._f("pgettext")("Invoice import", "Notification")
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpBox",
        { staticClass: "flex-fill", attrs: { direction: "column" } },
        [
          _c(
            "ItpBox",
            { attrs: { direction: "row" } },
            [
              _c("ItpText", {
                attrs: {
                  text: _vm._f("pgettext")("Invoice import", "Notification"),
                  small: "",
                  title: _vm.notification.description
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpBox",
            { attrs: { direction: "row" } },
            [
              _c("ItpText", {
                staticClass: "mr-1",
                style: _vm.b_1468474219929533_style,
                attrs: {
                  title: _vm.notification.data.company.name,
                  strong: "",
                  text: _vm.notification.data.company.name
                }
              }),
              _vm._v(" "),
              _vm.notification.data.company.id
                ? _c("ItpLink", {
                    attrs: {
                      icon: _vm.$config.externalLinkIcon,
                      to: {
                        name: "app.company",
                        params: { id: _vm.notification.data.company.id }
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "mx-2" }, [
                _vm._v("\n        ·\n      ")
              ]),
              _vm._v(" "),
              _vm.notification.data.invoice_kind
                ? _c("UcInvoiceKindBadge", {
                    attrs: { value: _vm.notification.data.invoice_kind }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ItpText", {
                staticClass: "mr-1",
                attrs: {
                  strong: "",
                  text: _vm.notification.data.invoice_number
                }
              }),
              _vm._v(" "),
              _vm.notification.data.invoice_id
                ? _c("ItpLink", {
                    attrs: {
                      icon: _vm.$config.externalLinkIcon,
                      to: {
                        name: "app.invoice",
                        params: { id: _vm.notification.key }
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "mx-2" }, [
                _vm._v("\n        ·\n      ")
              ]),
              _vm._v(" "),
              _c("ItpText", {
                staticClass: "mr-1",
                style: _vm.b_8385232899523842_style,
                attrs: {
                  title: _vm.notification.data.client.name,
                  strong: "",
                  text: _vm.notification.data.client.name
                }
              }),
              _vm._v(" "),
              _vm.notification.data.client.id
                ? _c("ItpLink", {
                    attrs: {
                      icon: _vm.$config.externalLinkIcon,
                      to: {
                        name: "app.company",
                        params: { id: _vm.notification.data.client.id }
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.notification.data.level === "warning"
            ? _c(
                "DIV",
                { staticClass: "mt-1" },
                [
                  _c(
                    "ItpBadge",
                    { staticClass: "mr-2", attrs: { variant: "warning" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.notification.description) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpBox",
        { staticClass: "align-self-center" },
        [
          _c(
            "ItpText",
            { attrs: { small: "", muted: "", title: _vm.notification.key } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("datetime")(_vm.notification.created_at)) +
                  "  " +
                  _vm._s(_vm._f("username")(_vm.notification.created_by)) +
                  "\n"
              ),
              _c("br")
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }